<template>
  <div>
    <el-form :inline="true" :model="queryInfo" class="demo-form-inline">
      <el-form-item label="操作模块：">
        <el-input v-model="queryInfo.operateModule" clearable @clear="initMethods" @change="current"></el-input>
      </el-form-item>
      <el-form-item label="操作类型：">
        <el-input v-model="queryInfo.operateType" clearable @clear="initMethods" @change="current"></el-input>
      </el-form-item>
      <!-- <el-button type="primary" icon="el-icon-search" @click="chaxun">查询</el-button> -->
      <el-button type="primary" icon="el-icon-refresh-left" @click="rest">重置</el-button>
    </el-form>
    <el-card>
      <el-table :data="tableList" border stripe @selection-change="handleSelectionChange" empty-text="暂无数据">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column align="center" label="ID序列" prop="id" width="80"></el-table-column>
        <el-table-column align="center" label="操作员" prop="adminName" width="90">
          <template slot-scope="scope">
               <span style="font-size: 14px;">{{ typename(scope.row.adminName) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作模块" prop="operateModule" width="190">
          <template slot-scope="scope">
            <span style="font-size: 14px;">{{ typename(scope.row.operateModule) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作类型" prop="operateType" width="190">
          <template slot-scope="scope">
            <span style="font-size: 14px;">{{ typename(scope.row.operateType) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="原数据(json)" prop="rawData" :show-overflow-tooltip='true'>
          <template slot-scope="scope">
            <span style="font-size: 14px;">{{ typename(scope.row.rawData) }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="新数据(json)" prop="newData" :show-overflow-tooltip='true'><template
            slot-scope="scope">
            <span style="font-size: 14px;">{{ typename(scope.row.newData) }}</span>
          </template></el-table-column>
        <el-table-column align="center" label="创建时间" prop="createTime" width="100">
          <template slot-scope="scope">
            <span style="font-size: 14px;"> {{ typename(scope.row.createTime || scope.row.dateFormat) }}</span>
          </template>
        </el-table-column>
        <!-- <el-table-column align="center" label="操作" width="130px" fixed="right">
          <template slot-scope="scope">
            <el-button size="small" type="danger" @click="removeById(scope.row)">删除</el-button>
          </template>
        </el-table-column> -->
      </el-table>
      <!-- 分页导航区域 -->
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="queryInfo.page" :page-sizes="[8, 20, 50, 100]" :page-size="queryInfo.limit"
        layout="total, sizes, prev, pager, next, jumper" :total="total" background>
      </el-pagination>
    </el-card>
  </div>
</template>
<script>
const adminId = window.sessionStorage.getItem('adminId');
export default {
  name: '',
  components: {

  },
  mixins: [],
  props: {

  },
  data() {
    return {
      tableList: [],
      ids: '', total: 0,
      queryInfo: {
        startTime: null,
        adminId: '',
        endTime: null,
        operateType: null,
        operateModule: null,
        page: 1,
        limit: 8
      },
    }
  },
  computed: {

  },
  watch: {

  },
  mounted() {
    this.queryInfo.adminId = adminId;
    this.initMethods();
  },
  methods: {
    current() {
      this.queryInfo.page = 1; this.initMethods();
    },
    rest() {
      this.queryInfo = {
        startTime: null,
        adminId,
        endTime: null,
        operateType: null,
        operateModule: null,
        page: 1,
        limit: 8
      };
      this.initMethods()
    },
    typename(value) {
      return !value || value == '' ? '--' : value
    },
    handleSelectionChange(value) {
      if (value.length == 0) return;
      this.ids = value.map(item => item.id).join(',')
    },
    // 监听pageSize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.limit = newSize;
      this.queryInfo.page = 1;
      this.initMethods()
    },
    // 监听页码值改变的事件
    handleCurrentChange(newPage) {
      this.queryInfo.page = newPage
      this.initMethods()
    },
    async initMethods() {
      const { data: res } = await this.$http.get('operationLog/getAllAdminOperationLog', { params: this.queryInfo })
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      }
      this.tableList = res.data;
      this.total = res.count
    },
    // 删除日志
    // async removeById(row) {
    //   const confirmResult = await this.$confirm('此操作将永久删除该日志, 是否继续?', '提示', {
    //     confirmButtonText: '确定',
    //     cancelButtonText: '取消',
    //     type: 'warning'
    //   }).catch(err => err)
    //   if (confirmResult !== 'confirm') {
    //     return this.$message.info('已经取消删除！')
    //   }
    //   if (row.id === null || row.id === '' || row.id === undefined) {
    //     const { data: res } = await this.$http.post('operationLog/delAdminOperationLogById/' + this.ids)
    //     if (res.code !== 0) {
    //       return this.$message.error('删除日志失败！')
    //     }
    //     this.$message.success('删除日志成功！')
    //     this.initMethods()
    // return
    //   }
    //     const { data: res } = await this.$http.post('operationLog/delAdminOperationLogById/' + row.id.toString())
    //     if (res.code !== 0) {
    //       return this.$message.error('删除日志失败！')
    //     }
    //     this.$message.success('删除日志成功！')
    //     this.initMethods()
    //   
    // }
  }
};
</script>
<style lang='' scoped>
</style>
